import calculateOneTimeImplementationCost from "../calculation/calculateOneTimeImplementationCost";
const getImplementationCostCatagory = (initiative) => {
  if (!initiative || (!initiative.impact && !initiative.KPI)) {
    return 'No value';
  }
  let totalImplementationCost = calculateOneTimeImplementationCost(initiative);
  if (totalImplementationCost < 0) {
    return 'Negative value';
  } else if (totalImplementationCost === 0) {
    return 'ETB 0-ETB 1Mn';
  } else if (totalImplementationCost <= 1) {
    return 'ETB 0-ETB 1Mn';
  } else if (totalImplementationCost <= 10) {
    return 'ETB 1Mn-ETB 10Mn';
  } else if (totalImplementationCost <= 50) {
    return 'ETB 10Mn-ETB 50Mn';
  } else if (totalImplementationCost <= 100) {
    return 'ETB 50Mn-ETB 100Mn';
  } else if (totalImplementationCost <= 500) {
    return 'ETB 100Mn-ETB 500Mn';
  } else if (totalImplementationCost <= 1000) {
    return 'ETB 500Mn-ETB 1Bn';
  } else {
    return '>ETB 1Bn';
  }
};

export default getImplementationCostCatagory;